import React, { useState, useEffect } from "react";
import DialogForm from "@/components/modal/DialogForm";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Select, MenuItem, TextField, Box, Input, Button, CircularProgress  } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DataTable from "@/components/dataTableComponents/DataTable";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { LineDivider, StyledButton } from "@/components";
import { useAddWeekendPolicyMutation, useUpdateWeekendPolicyMutation } from "@/api/services/attendanceManagement/weekendPolicy/WeekendPolicy";
import { toast } from "@/components/toastify";

function SelectWeekendPolicy({ open, setOpen, selectedRow, setSelectedRow, refetch }) {
  const [weekendPolicy, setWeekendPolicy] = useState([]);
  const [date, setDate] = useState();
  const [countval, setcountval] = useState(0);
  const [selectedSatOptions, setSelectedSatOptions] = useState(
    Array(countval || 1).fill("Off") // Ensure valid default array
  );

  const [addWeekendPolicy, { isLoading: isLoadingAdd }] = useAddWeekendPolicyMutation();
  const [updateWeekendPolicy, { isLoading: isLoadingUpdate }] = useUpdateWeekendPolicyMutation();
  const isSubmitting = isLoadingAdd || isLoadingUpdate;

  useEffect(() => {
    if (selectedRow) {
      setDate(selectedRow.month ? dayjs(selectedRow.month, "MM-YYYY") : null);

      const weekendData = selectedRow?.week || [];

      const initialSatOptions = weekendData.map(week => week.satStatus || "Off");
      setSelectedSatOptions(initialSatOptions);

      const updatedWeekendPolicy = weekendData.map((week, index) => ({
        id: index + 1,
        weekName: week.weekName,
        satStatus: (
          <>
            <Select
              name="sat_week[]"
              defaultValue={selectedSatOptions[index] ?? week.satStatus}
              onChange={(e) => {
                handleSatSelectChange(e.target.value, index);
              }}
              size="small"
              fullWidth
            >

              <MenuItem value="Off">Off</MenuItem>
              <MenuItem value="Working">Working</MenuItem>
            </Select>
            <Input type="hidden" name="sat_date[]" value={week.satDate} />
          </>
        ),
        sunStatus: (
          <>
            <Select name="sun_week[]" value={week.sunStatus} size="small" fullWidth disabled>
              <MenuItem value="Off">Off</MenuItem>
              <MenuItem value="Working">Working</MenuItem>
            </Select>
            <Input type="hidden" name="sun_date[]" value={week.sunDate} />
          </>
        ),
      }));

      setWeekendPolicy(updatedWeekendPolicy);
    } else {
      setDate(null);
      setWeekendPolicy([]);
      setSelectedSatOptions([]);
    }
  }, [selectedRow]);



  const handleSatSelectChange = (value, index) => {
    setSelectedSatOptions((prevOptions) => {
      const updatedOptions = [...prevOptions];
      updatedOptions[index] = value?.trim() ? value : "Off";
      return updatedOptions;
    });
  };

  const handleCloseDialog = () => {
    setSelectedRow(null);
    setWeekendPolicy([]);  // Ensure `setWeekendPolicy` is correctly initialized
    setDate(null);
    setSelectedSatOptions([]);
    setOpen(false);
  }

  useEffect(() => {
    if (!open) {
      // resetForm();
    }
  }, [open]);


  useEffect(() => {
    if (!open || !selectedRow) {
      setDate(null);
      setWeekendPolicy([]);
      setSelectedSatOptions([]);
      setcountval(0);
    }
  }, [open,selectedRow]);

  const handleDatePickerChange = (newDate) => {
    if (!newDate) return;

    const mon = newDate.format("YYYY-MM");
    const year = newDate.format("YYYY");
    const month = newDate.format("MM") - 1;
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const sat = [];
    const sun = [];

    for (let i = 1; i <= daysInMonth; i++) {
      const currentDay = new Date(year, month, i);
      if (currentDay.getDay() === 0) sun.push(i);
      if (currentDay.getDay() === 6) sat.push(i);
    }

    const count = sat.length !== 5 && sun.length !== 5 ? 4 : 5;
    setcountval(count);
    setSelectedSatOptions(Array(count).fill("Off"));
    const updatedWeekendPolicy = Array.from({ length: count }, (_, i) => {
      const index = i + 1;
      return {
        id: index,
        weekName: `Week ${index}`,
        satStatus: sat[i] ? (
          <>
            <Select
              name="sat_week[]"
              defaultValue="Off"
              onChange={(e) => handleSatSelectChange(e.target.value, i)}
              size="small"
              fullWidth
            >
              <MenuItem value="Off">Off</MenuItem>
              <MenuItem value="Working">Working</MenuItem>
            </Select>
            <Input
              type="hidden"
              name="sat_date[]"
              value={`${mon}-${String(sat[i]).padStart(2, "0")}`}
            />
          </>
        ) : (
          <Input type="hidden" name="sat_week[]" value="no" />
        ),
        sunStatus: (
          <>
            <Select defaultValue="Off" name="sun_week[]" size="small" fullWidth disabled>
              <MenuItem value="Off">Off</MenuItem>
              <MenuItem value="Working">Working</MenuItem>
            </Select>
            <Input
              type="hidden"
              name="sun_date[]"
              value={`${mon}-${String(sun[i] || "").padStart(2, "0")}`}
            />
          </>
        ),
      };
    });

    setWeekendPolicy(updatedWeekendPolicy);
    setDate(newDate);
  };


  const handleSubmit = () => {
    const yearMonth = date ? date.format("MM-YYYY") : "";
    // const rawSatDate = weekendPolicy.map((week) =>
    //   week.satStatus.props.children[1]?.props.value || ""
    // );
    const rawSatDate = weekendPolicy.map((week) => {
      const children = week.satStatus?.props?.children;
      return Array.isArray(children) && children[1]?.props?.value ? children[1].props.value : "";
    });
    const rawSatStatus = (selectedSatOptions && selectedSatOptions.length > 0)
      ? selectedSatOptions.map((status) => status?.trim() ? status : "Off") // Replace empty values with "Off"
      : Array(satDate.length).fill("Off");

    // const rawSunDate = weekendPolicy.map((week) =>
    //   week.sunStatus.props.children[1]?.props.value || ""
    // );
    const rawSunDate = weekendPolicy.map((week) => {
      const children = week.sunStatus?.props?.children;
      return Array.isArray(children) && children[1]?.props?.value ? children[1].props.value : "";
    });
    const rawSunStatus = weekendPolicy.map((week) =>
      week.sunStatus.props.children[0]?.props.children[0]?.props.value || "Off"
    );

    const satDate = [];
    const satStatus = [];
    rawSatDate.forEach((date, i) => {
      if (date && !date.endsWith("-00")) {
        satDate.push(date);
        satStatus.push(rawSatStatus[i]);
      }
    });

    const sunDate = [];
    const sunStatus = [];
    rawSunDate.forEach((date, i) => {
      if (date && !date.endsWith("-00")) {
        sunDate.push(date);
        sunStatus.push(rawSunStatus[i]);
      }
    });

    const formattedData = {
      month: yearMonth,
      satDate,
      satStatus,
      sunDate,
      sunStatus
    };
    if (selectedRow) {
      // Update existing policy
      updateWeekendPolicy({ id: selectedRow.id, data: formattedData, yearMonth: yearMonth })
        .unwrap()
        .then((response) => {
          toast("success", "Updated Successfully!");
          setOpen(false);
          setDate(null);
          setWeekendPolicy([]);
          setSelectedSatOptions([]);
          setSelectedRow(null);
          refetch()
        })
        .catch((error) => {
          console.error("Update failed:", error);
        });
    } else {
      // Add new policy
      addWeekendPolicy({ data: formattedData })
        .unwrap()
        .then((response) => {
          toast("success", "Added Successfully!");
          setOpen(false);
          setDate(null);
          setWeekendPolicy([]);
          setSelectedSatOptions([]);
          setSelectedRow(null);
          refetch();
        })
        .catch((error) => {
          //  const errorMessage = error?.data?.message || "Something went wrong while adding.";
          //  toast("error", errorMessage);
          // console.error("Addition failed:", error);
        });
    }

  };

  const columns = [
    { field: "weekName", headerName: "Week", width: 100, flex: 1 },
    {
      field: "satStatus",
      headerName: "Saturday",
      renderCell: (params) => params.value,
      width: 350,
    },
    {
      field: "sunStatus",
      headerName: "Sunday",
      renderCell: (params) => params.value,
      width: 350,
    },
  ];

  return (
    <DialogForm
      // title="Select Weekend Policy"
      title={selectedRow ? "Update Weekend Policy" : "Add Weekend Policy"}
      open={open}
      setOpen={setOpen}
      width="md"
    >
      <Box padding={2}>
        <Box padding={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["year", "month"]}
              openTo="month"
              // label="Select Month"
              value={date}
              components={{ OpenPickerIcon: CalendarMonthIcon }}
              onChange={handleDatePickerChange}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Select Month" />
              )}
              // slotProps={{
              //   textField: {
              //     placeholder: "Select Month fghj", // Ensure placeholder is shown when empty
              //   },
              // }}

              slotProps={{
                textField: {
                  // fullWidth: true,
                  variant: "outlined",
                  placeholder: "Select Month",
                  sx: {
                    "& .MuiInputBase-input": {
                      padding: "10px",
                      height: "100%",
                      boxSizing: "border-box",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderRadius: "8px",
                      borderWidth: "1px",
                    },
                  },
                  InputLabelProps: { shrink: true },
                },
              }}

            />
          </LocalizationProvider>
        </Box>
        <Box >
          <DataTable
            columns={columns}
            rows={weekendPolicy}
            tableTitle="Weekend Policy"
            hidePagination
            sx={{
              "& .MuiDataGrid-row": {
                border: "2px solid lightgray",
                borderRadius: "5px",
                backgroundColor: "white",
                width: "calc(100% - 2px)",
                marginTop: 3,
              },
            }}
          />
        </Box>
        <LineDivider />
        <Box display="flex" justifyContent="flex-end" marginTop={2}>
          <Button variant="outlined" color="primary" sx={{ marginRight: 2 }}
            onClick={() => { handleCloseDialog() }}
          >
            Close
          </Button>
          {/* <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            style={{ marginLeft: 8 }}
          >
            {selectedRow ? "Update" : "Add"}
          </Button> */}
          <StyledButton
            type="submit"
            label={
              isSubmitting ? (
                <CircularProgress size={24} color="inherit" />
              ) : selectedRow ? (
                "Update"
              ) : (
                "Add"
              )
            }
            variant="contained"
            onClick={handleSubmit}
          />
        </Box>
      </Box>
    </DialogForm>
  );
}

export default SelectWeekendPolicy;
